<label [for]="inputId()" class="inline-flex cursor-pointer items-center gap-2">
  <input
    type="checkbox"
    [id]="inputId()"
    [formControl]="control()"
    class="peer sr-only"
  />
  <span [ngClass]="boxClasses()">
    <svg
      [ngClass]="checkmarkClasses()"
      viewBox="0 0 12 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path
        d="M1 5.5L4.5 9L11 2"
        stroke="white"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  </span>
</label>
